import { getResponseDoPayment as _getResponseDoPayment } from "app/redux/actions/doPayment";
import { compose, lifecycle, withState } from "recompose";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslator } from "app/decorators";
import CheckoutProcess from "./CheckoutProcess";
import axios from "axios";
import fetchToken from "shadow-client/axios/fetchToken";

function getUrlPayId() {
  return window.location.href.split("?transaction=")[1];
}

function componentWillMount() {
  const paymentId = getUrlPayId();

  this.props.getResponseDoPayment(paymentId).then(responseDoPayment => {
    const redirectUrl = responseDoPayment.get("redirectUrl");

    fetchToken().then(responseToken => {
      axios
        .get(redirectUrl, {
          headers: {
            Authorization: "Bearer " + responseToken
          }
        })
        .then(responseForm => {
          this.props.setFormPayment(responseForm.data);
          this.props.setIsLoading(false);
        });
    });
  });
}

export default compose(
  withRouter,
  connect(null, {
    getResponseDoPayment: _getResponseDoPayment
  }),
  withState("isLoading", "setIsLoading", true),
  withState("formPayment", "setFormPayment", ""),
  lifecycle({ componentWillMount }),
  withTranslator
)(CheckoutProcess);



// WEBPACK FOOTER //
// ./src/app/components/CheckoutProcess/CheckoutProcessContainer.js